import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Observable } from 'rxjs';
import { RentalObjectType } from './../../model/rental-object-type';
import { RentalObjectCategory } from './../../model/const/enums';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class RentalObjectTypeService extends DataService<RentalObjectType> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, RentalObjectType, progressBar, 'rental-object-type');
  }

  getByCategory(category: RentalObjectCategory): Observable<RentalObjectType[]> {
    return this.client.get<RentalObjectType[]>(this.endpoint + `/category/${category}`);
  }
}
